export default "__VITE_ASSET__CbTiFdXr__"